// API Configuration
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://sekhar-portfolio-api.onrender.com'
};

export default config;
